module.exports = __webpack_public_path__ + "img/JORGE-CASTANHO-LDA-LOGOTIPO-TRANSP.58b5be40.png";